export default "__VITE_ASSET__5yWsFV7m__"